import React from 'react';
import {Link as RouterLink, useLocation} from 'react-router-dom';
import {AppBar, Box, Button, Toolbar, Tooltip} from '@mui/material';
import {useAuth} from '../auth/AuthContext';

export default function PublicAppBar({preference = 'auto', onThemeChange, navbarRef}) {
    const {isAuthenticated} = useAuth();
    const {pathname} = useLocation();
    return (
        <AppBar ref={navbarRef} position="sticky" elevation={0} aria-label="Navigare principală"
            sx={{bgcolor: 'background.default', color: 'text.primary', borderBottom: 1, borderColor: 'divider'}}>
            <Toolbar sx={{gap: {xs: 1, sm: 3}, flexWrap: 'wrap', py: 1.5, width: '100%', maxWidth: 1200, mx: 'auto'}}>
                <Box sx={{display: 'inline-flex', alignItems: 'baseline', fontFamily: 'Georgia, serif', fontSize: 27, letterSpacing: '-1px', flexShrink: 0}}>
                    <Box component={RouterLink} to="/" aria-label="ArtaNFT — Acasă"
                        sx={{color: 'text.primary', textDecoration: 'none', '&:hover': {color: 'primary.main', textDecoration: 'none'}}}>Arta</Box>
                    <Tooltip title="Ce înseamnă NFT?">
                        <Box component={RouterLink} to="/nft" aria-label="NFT — Ce înseamnă NFT?" aria-current={pathname === '/nft' ? 'page' : undefined}
                            sx={{color: 'primary.main', textDecoration: 'none', '&:hover': {color: 'primary.main', textDecoration: 'underline', textUnderlineOffset: '5px'}}}>NFT</Box>
                    </Tooltip>
                </Box>
                <Box sx={{flexGrow: 1}} />
                {/* Pasul 38: fără prefixul „Temă:” — selectorul încape lângă „Autentificare” pe telefon. */}
                <Box component="select" aria-label="Tema de afișare" value={preference} onChange={(e) => onThemeChange?.(e.target.value)}
                    title="Automat: nocturn între 19:00 și 07:00, ora locală"
                    sx={{bgcolor: 'background.paper', color: 'text.primary', border: 1, borderColor: 'divider', borderRadius: 1, p: 1, fontSize: 14, maxWidth: '100%'}}>
                    <option value="auto">Automat</option>
                    <option value="light">Luminos</option>
                    <option value="dark">Nocturn</option>
                </Box>
                {isAuthenticated && <Button component={RouterLink} to="/contact" size="small">Contact</Button>}
                <Button component={RouterLink} to={isAuthenticated ? '/admin' : '/login'} color="primary" variant="outlined" size="small">
                    {isAuthenticated ? 'Panoul meu' : 'Autentificare'}
                </Button>
            </Toolbar>
        </AppBar>
    );
}
